import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  isLoading: false,
  session: {},
  orientation: {},
};

function onLoadSession(state) {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadSessionSuccess(state, { payload }) {
  return {
    ...state,
    isLoading: false,
    session: payload,
  };
}

function onLoadOrientationDetailsSuccess(state, { payload }) {
  return {
    ...state,
    orientation: payload,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoadSession,
  [actions.LOAD_SUCCESS]: onLoadSessionSuccess,
  [actions.LOAD_ORIENTATION_DETAILS_SUCCESS]: onLoadOrientationDetailsSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
